module.exports = __webpack_public_path__ + "img/housekeeping.a9d33a33.jpeg";